<template>
  <div class="provinceFixPriceTable">
    <el-form ref="formTool" :inline="true" style="text-align: left">
      <el-table v-loading="loading" :data="areaData" style="width: 100%">
        <!-- <el-table-column label="省" prop="provinceName" width="140px">
          </el-table-column> -->
        <el-table-column label="客户名称" prop="customerShopName" width="150">
        </el-table-column>
        <el-table-column label="销售定价" prop="price" width="170">
          <template slot-scope="scope">
            <div class="unit-box">
              <span
                ><el-input
                  disabled
                  v-model="scope.row.price"
                  class="tag-input"
                  style="width: 100px"
                  size="mini"
                  oninput="value= value.match(/\d+(\.\d{0,2})?/) ? value.match(/\d+(\.\d{0,2})?/)[0] : ''"
                ></el-input
              ></span>
              <span class="unit-s"> 元/{{ scope.row.goodsSkuUnit }} </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="合作医药公司名称" prop="shopName" width="200">
          <template slot-scope="scope">
            <el-select
              size="mini"
              disabled
              v-model="scope.row.shopName"
              @change="
                (val) => {
                  reservationChange(val, scope.$index, 1);
                }
              "
            >
              <el-option
                v-for="item in medicineManager"
                :key="item.shopId"
                :label="item.shopName"
                :value="item"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="医药公司康贝" prop="shopName" width="130">
          <template slot-scope="scope">
            <el-select
              size="mini"
              disabled
              v-model="scope.row.merchantNo"
              @change="
                (val) => {
                  reservationChange(val, scope.$index, 1);
                }
              "
            >
              <el-option
                v-for="item in scope.row.merchantNoArr"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="销售金额" prop="amount" width="120">
          <template slot-scope="scope">
            <span
              ><el-input
                disabled
                v-model="scope.row.amount"
                class="tag-input"
                style="width: 100px"
                size="mini"
                oninput="value= value.match(/\d+(\.\d{0,2})?/) ? value.match(/\d+(\.\d{0,2})?/)[0] : ''"
              ></el-input
            ></span>
          </template>
        </el-table-column>
        <el-table-column label="地区公司名称" prop="city_shopName" width="200">
          <template slot-scope="scope">
            <el-select
              size="mini"
              clearable
              v-model="scope.row.city_shopName"
              disabled
              @change="
                (val) => {
                  reservationChange(val, scope.$index, 2);
                }
              "
            >
              <el-option
                v-for="(item, index) in cityManager"
                :key="item.shopId + index"
                :label="item.shopName"
                :value="item"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="地区公司康贝" prop="city_shopName" width="130">
          <template slot-scope="scope">
            <el-select
              size="mini"
              clearable
              v-model="scope.row.city_merchantNo"
              disabled
              @change="
                (val) => {
                  reservationChange(val, scope.$index, 2);
                }
              "
            >
              <el-option
                v-for="item in scope.row.city_merchantNoArr"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="服务费金额" prop="city_amount" width="120">
          <template slot-scope="scope">
            <span
              ><el-input
                disabled
                v-model="scope.row.city_amount"
                style="width: 100px"
                size="mini"
                oninput="value= value.match(/\d+(\.\d{0,2})?/) ? value.match(/\d+(\.\d{0,2})?/)[0] : ''"
              ></el-input
            ></span>
          </template>
        </el-table-column>
        <el-table-column
          label="省区公司名称"
          prop="serviceShopName"
          width="200"
        >
          <template slot-scope="scope">
            <el-select
              size="mini"
              disabled
              v-model="scope.row.serviceShopName"
              @change="
                (val) => {
                  reservationChange(val, scope.$index, 3);
                }
              "
            >
              <el-option
                v-for="item in provinceManager"
                :key="item.shopId"
                :label="item.shopName"
                :value="item"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          label="省区公司康贝"
          prop="serviceShopName"
          width="130"
        >
          <template slot-scope="scope">
            <el-select
              size="mini"
              disabled
              v-model="scope.row.serviceMerchantNo"
              @change="
                (val) => {
                  reservationChange(val, scope.$index, 3);
                }
              "
            >
              <el-option
                v-for="item in scope.row.serviceMerchantNoArr"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          label="地区需转账省区"
          prop="serviceAmount"
          width="120"
        >
          <template slot-scope="scope">
            <span
              ><el-input
                disabled
                v-model="scope.row.serviceAmount"
                style="width: 100px"
                size="mini"
                oninput="value= value.match(/\d+(\.\d{0,2})?/) ? value.match(/\d+(\.\d{0,2})?/)[0] : ''"
              ></el-input
            ></span>
          </template>
        </el-table-column>
        <!-- <el-table-column
            label="启用状态"
            prop="status"
            align="center"
            fixed="right"
            min-width="105"
          >
            <template slot-scope="scope">
             <span>{{scope.row.status == 'PUTAWAY'?'已启用':'未启用'}}</span>
            </template>
          </el-table-column> -->

          <el-table-column label="省学术公司" prop="studyShopName" width="200">
          <template slot-scope="scope">
            <el-select
              size="mini"
              disabled
              v-model="scope.row.studyShopName"
              @change="
                (val) => {
                  reservationChange(val, scope.$index, 4);
                }
              "
            >
              <el-option
                v-for="item in provinceManager"
                :key="item.shopId"
                :label="item.shopName"
                :value="item"
              />
            </el-select>
          </template>
        </el-table-column>

        <el-table-column label="省学术康贝" prop="studyMerchantNo" width="200">
          <template slot-scope="scope">
            <el-select
              size="mini"
              disabled
              v-model="scope.row.studyMerchantNo"
              @visible-change="
                (val) => {
                  getListByShopIdFn(val, scope.row, 3);
                }
              "
            >
              <el-option
                v-for="(item, key) in listByShopId3"
                :key="key"
                :label="item.merchantNo"
                :value="item.merchantNo"
              >
                <span style="color: #8492a6; font-size: 13px">
                  康贝号: {{ item.merchantNo }}</span
                >
                <span> {{ item.merchantName }}</span>
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="省区需转学术" prop="studyAmount" width="140">
          <template slot-scope="scope">
            <div class="unit-box">
              <span>
                <el-input
                disabled
                  v-model="scope.row.studyAmount"
                  style="width: 100px"
                  size="mini"
                  oninput="value= value.match(/\d+(\.\d{0,2})?/) ? value.match(/\d+(\.\d{0,2})?/)[0] : ''"
                >
                
                </el-input></span
              >
            </div>
          </template>
        </el-table-column>
        
        <el-table-column
          label="启用状态"
          prop="status"
          align="center"
          fixed="right"
          min-width="105"
        >
          <template slot-scope="scope">
            <div class="siwtchView">
              <el-switch
                v-model="scope.row.status"
                active-value="PUTAWAY"
                inactive-value="SOLDOUT"
                active-color="#67c23a"
                inactive-color="#999"
                class="switchStyle"
                v-if="scope.row.productLineId"
                @change="changeStatus(scope.row, scope.$index)"
              />
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <Pagination
      v-show="areaData.length > 0"
      :total="page.total"
      :page-sizes="page.pageSizes"
      :page.sync="page.current"
      :limit.sync="page.size"
      @pagination="pageChange"
    />
  </div>
</template>
  
  <script>
import {
  getAreaCompany,
  getPageShopSkuPrice,
  skuUpdateStatus,
  getProductLineSkuList,
} from "@/api/saleRule/productLine";
import Pagination from "@/components/Pagination";
export default {
  components: { Pagination },
  props: {
    goodsId: {
      type: String,
      default() {
        return null;
      },
    },
    goodsName: {
      type: String,
      default() {
        return "";
      },
    },
    orgCode: {
      type: String,
      default() {
        return null;
      },
    },
    orgName: {
      type: String,
      default() {
        return "";
      },
    },
    shopName: {
      type: String,
      default() {
        return "";
      },
    },
    tableData: {
      type: Array,
      default() {
        return [];
      },
    }, // 列表数据
    unitList: {
      type: Array,
      default() {
        return [];
      },
    }, // 单位数据
  },
  data() {
    return {
      formTool: {},
      loading: false,
      rules: {
        price: [{ required: true, message: "请输入销售定价", trigger: "blur" }],
      },
      dialogVisible: false,
      provinceCode: 430000,
      provinceName: "",
      areaListArr: [],
      areaData: [],
      medicineManager: [],
      cityManager: [],
      provinceManager: [],
      goodsSkuUnit: "盒",
      unitKey: 0,
      companyList: [], //医药公司名称
      areaCodeList: [], //区域code集合
      page: {
        total: 10,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50, 100],
      },
    };
  },
  created() {
    // this.init(this.provinceCode);
  },
  //   @Schema(description = "状态：PUTAWAY.上架,SOLDOUT.下架")
  // private String status;
  methods: {
    resetData() {
      this.page.current = 1;
      this.page.size = 10;
      this.total = 10;
      this.areaData = [];
    },
    init(provinceCode) {
      if (provinceCode) {
        this.provinceCode = provinceCode;
        this.getAreaCompanyFn(); // 统一分账获取省地办
      } else {
        this.getAreaCompanyFn(); // 统一分账获取省地办
      }
    },
    // 统一分账获取省地办
    getAreaCompanyFn() {
      this.loading = true;
      let params = {
        orgCode: this.provinceCode, // provinceId 省区id
      };
      getAreaCompany(params).then((res) => {
        this.cityManager = res.cityManager; //市级 公司 列表
        this.provinceManager = res.provinceManager; // 省级公司列表
        this.medicineManager = res.medicineManager; //医药公司列表
        this.getSelfPriceAndLedgerRuleFn();
      });
    },

    // 获取分账管理列表
    getSelfPriceAndLedgerRuleFn() {
      console.log(this.goodsId);
      if (this.goodsId == "") return;
      let params = {
        goodsId: this.goodsId,
        orgCode: this.orgCode,
        orgName: this.orgName,
        shopName: this.shopName,
        current: this.page.current,
        size: this.page.size,
      };
      getPageShopSkuPrice(params)
        .then((res) => {
          this.loading = false;
          if (res && res.records && res.records.length) {
            this.page.total = res.total;
            // this.areaData = res.records;
            this.initShopSkuListPrice(res.records);
          } else {
            this.areaData = [];
          }
        })
        .catch((error) => {
          this.areaData = [];
          this.loading = false;
        });
    },

    initShopSkuListPrice(data) {
      data.map((e) => {
        // item.areaCode = e.areaCode;
        // item.areaName = e.areaName;
        // item.ledgerRulesId = e.ledgerRulesId;
        // item.productLineId = e.productLineId;
        // item.goodsId = e.goodsId;
        // item.goodsName = e.goodsName;
        // item.goodsSkuPriceId = e.goodsSkuPriceId;
        // item.goodsSkuUnit = e.goodsSkuUnit;
        // item.provinceCode = e.provinceCode;
        // item.provinceName = e.provinceName;
        // item.price = e.price; //销售定价
        // item.status = e.status;

        //医药公司
        if (e.drugLedgerRules) {
          e.amount = e.drugLedgerRules.amount;
          e.drug_id = e.drugLedgerRules.id;
          e.drug_ledgerRulesId = e.drugLedgerRules.ledgerRulesId;
          e.merchantNo = e.drugLedgerRules.merchantNo;
          e.shopId = e.drugLedgerRules.shopId;
          e.shopName = e.drugLedgerRules.shopName;
        }
        if (e.cityLedgerRules) {
          e.city_id = e.cityLedgerRules.id;
          e.city_ledgerRulesId = e.cityLedgerRules.ledgerRulesId;
          e.city_merchantNo = e.cityLedgerRules.merchantNo;
          e.city_amount = e.cityLedgerRules.amount;
          e.city_shopId = e.cityLedgerRules.shopId;
          e.city_shopName = e.cityLedgerRules.shopName;

          //地区需转省区公司
          e.serviceAmount = e.cityLedgerRules.serviceAmount;
          e.serviceMerchantNo = e.cityLedgerRules.serviceMerchantNo;
          e.serviceShopId = e.cityLedgerRules.serviceShopId;
          e.serviceShopName = e.cityLedgerRules.serviceShopName;

             //省区学术
          e.studyAmount = e.cityLedgerRules.studyAmount;
          e.studyMerchantNo = e.cityLedgerRules.studyMerchantNo;
          e.studyShopId = e.cityLedgerRules.studyShopId;
          e.studyShopName = e.cityLedgerRules.studyShopName;
        }
        //地区公司
      });
      this.areaData = data;
    },

    // goodsSkuPriceId
    changeStatus(row, index) {
      if (row.status != "PUTAWAY") {
        this.$confirm("此操作将不启用当前分账规则, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.updateStatus(row);
          })
          .catch(() => {
            this.areaData[index].status = "PUTAWAY";
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      } else {
        if (!row.amount) {
          this.$message.warning("未设置特殊定价，无法启用");
          this.areaData[index].status = "SOLDOUT";
        } else {
          this.updateStatus(row);
        }
      }
    },

    updateStatus(row) {
      let params = {
        skuId: row.goodsSkuPriceId,
        status: row.status == "PUTAWAY" ? 1 : 2,
      };
      skuUpdateStatus(params).then((res) => {
        console.log(res);
        if (res) {
          this.$message({
            message: `修改成功！`,
            type: "success",
          });
        }
      });
    },

    // 合并第一列单元格
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
    },

    // 点击选择单位choseUnit
    choseUnit(e, key) {
      // console.log(e, "e");  console.log(key, "key");
      this.unitKey = key;
      this.goodsSkuUnit = e;
    },

    // 确认选择单位
    choseUnitSure() {
      this.areaData[this.currentRowIndex].goodsSkuUnit = this.goodsSkuUnit;
      this.dialogVisible = false;
    },

    // 设置下拉选择 值
    reservationChange(val, index, type) {
      //这样就可以传递自定义的参数了
      console.log(val, "--val--", index, "--index--", type, "type");
      let arr = val.merchantNo.split(",");
      if (type == 1) {
        this.areaData[index].shopName = val.shopName;
        this.areaData[index].shopId = val.shopId;
        this.areaData[index].merchantNoArr = arr;
        this.areaData[index].merchantNo = arr[0];
        // 调用sku接口
        this.getProductLineSkuList(val.shopId, "select", index);
      }
      // console.log(this.areaData[index]);
      if (type == 2) {
        this.areaData[index].city_shopName = val.shopName;
        this.areaData[index].city_shopId = val.shopId;
        this.areaData[index].city_merchantNoArr = arr;
        this.areaData[index].city_merchantNo = arr[0];
      }
      if (type == 3) {
        this.areaData[index].serviceShopName = val.shopName;
        this.areaData[index].serviceShopId = val.shopId;
        this.areaData[index].serviceMerchantNoArr = arr;
        this.areaData[index].serviceMerchantNo = arr[0];
      }
    },

    objectSpanMethod({ row, column, rowIndex, columnIndex }, value) {
      if (columnIndex === 0) {
        if (rowIndex === 0) {
          return {
            rowspan: value.length,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },

    // 打开选择单位弹窗
    openDaliog(row, rowIndex) {
      this.dialogVisible = true;
      this.currentRowIndex = rowIndex;
      console.log(row, rowIndex);
    },

    getProductLineSkuList(shopId, type, index) {
      let params = {
        goodsId: this.goodsId,
        shopId: shopId,
        areaCodeSet: this.areaCodeList,
      };
      console.log(params, "params");
      getProductLineSkuList(params)
        .then((res) => {
          let resp = res;
          console.log(type, "type");

          this.areaData.map((item) => {
            for (let e of resp) {
              if (type == "select") {
                // console.log(e,'e')
                if (this.areaData[index].areaCode == e.areaCode) {
                  console.log(e, "e");
                  this.areaData[index].productLineId = e.productLineId;
                  this.areaData[index].goodsSkuPriceId = e.goodsSkuPriceId;
                  break;
                }
              } else {
                if (item.areaCode == e.areaCode && !item.productLineId) {
                  item.productLineId = e.productLineId;
                  item.goodsSkuPriceId = e.goodsSkuPriceId;
                }
              }
            }
          });

          console.log(this.areaData, "this.areaData");
        })
        .catch((err) => {});
    },

    // 全局应用设置价格数据
    save(from) {
      // console.log("from", from);
      // 全局设置 循环填充数据
      for (let item of this.areaData) {
        // 如果本条数据是上架状态，本条数据不做修改
        if (item.status == "PUTAWAY") {
          continue;
        }
        if (from.price) {
          item.price = parseFloat(from.price); //销售定价
        }
        if (from.amount) {
          item.amount = parseFloat(from.amount); //销售金额
        }
        if (from.city_amount && item.city_shopName != "") {
          item.city_amount = parseFloat(from.city_amount); //服务费用
        }
        if (item.city_shopName == "") {
          item.city_amount = "";
        }
        if (from.serviceAmount) {
          item.serviceAmount = parseFloat(from.serviceAmount); //地区需转账省区
        }
        if (from.goodsSkuUnit) {
          item.goodsSkuUnit = from.goodsSkuUnit;
        }
      }

      console.log(this.areaData, "this.areaData");
      this.$forceUpdate();
    },

    handleClose() {
      this.dialogVisible = false;
    },
    pageChange(e) {
      this.page.size = e.limit;
      this.page.current = e.page;
      this.getSelfPriceAndLedgerRuleFn();
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.provinceFixPriceTable {
  .tag-input {
    width: 200px;
  }
  .content-box {
    margin: 10px;
    .unit {
      padding: 5px;
      border: solid 1px #eee;
      color: #333;
      border-radius: 5px;
      margin: 0 5px;
      line-height: 40px;
    }
    .unit:hover {
      background: rgb(255, 73, 73);
      color: #fff;
      cursor: pointer;
    }
    .active {
      background: rgb(255, 73, 73);
      color: #fff;
    }
  }
  .unit-box {
    display: flex;
  }
  .unit-s {
    margin: 5px;
    color: #333;
  }

  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
  .siwtchView {
    .switchStyle {
      height: 30px;
      line-height: 30px;
    }

    .el-switch__label {
      width: 65px !important;
      height: 30px !important;
      position: absolute;
      left: 0px !important;
      border-radius: 15px;
      display: none;
      color: #fff !important;
      &--left {
        z-index: 9;
        left: 10px !important;
      }

      &--right {
        z-index: 9;
        left: -20px !important;
      }

      &.is-active {
        display: block;
      }
    }

    .el-switch__core {
      width: 65px !important;
      height: 30px !important;
      border-radius: 15px;
      &::after {
        top: 4px;
        left: 5px;
        width: 20px;
        height: 20px;
        border-radius: 10px;
      }
    }

    .is-checked {
      .el-switch__core {
        &::after {
          left: 55px !important;
        }
      }
    }
  }
}
</style>